/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Card_DescriptionInputs */

const en_samples_card_description = /** @type {(inputs: Samples_Card_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click the actions menu on a row to edit details.`)
};

const es_samples_card_description = /** @type {(inputs: Samples_Card_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haga clic en el menu de acciones de una fila para editar detalles.`)
};

/**
* | output |
* | --- |
* | "Click the actions menu on a row to edit details." |
*
* @param {Samples_Card_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_card_description = /** @type {((inputs?: Samples_Card_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Card_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_card_description(inputs)
	return es_samples_card_description(inputs)
});